module.exports = __webpack_public_path__ + "static/media/cover_banner.2feab05e.png";